<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12 text-left">
                <a @click="$router.go(-1)" class="btn btn-link btn-back-link">&laquo; Back</a>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Offer Details</h1>
            </div>
        </div>

        <div class="row" v-if="errorMessages.length > 0">
            <div class="col-12">
                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="offerFetched && offer !== ''">
            <div class="col-12 offer-detail-wrapper">
                <div class="offer-detail-img-wrapper">
                    <img class="img img-fluid" :src="getOfferImage()" />
                </div>
                <div class="offer-details">
                    <p class="offer-valid" v-if="offer.startDate || offer.endDate" v-html="formatDateRange()"></p>
                    <h2>{{ offer.description }}</h2>
                    <h3 v-html="formatReward()"></h3>
                    <p>{{ offer.longDescription }}</p>
                    <div class="terms-and-conditions">
                        <p class="small">
                            <strong>Terms & Conditions</strong>
                            <br/>
                            {{ offer.termsAndConditions }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else-if="!offerFetched">
            <div class="col-12">
                <div class="spinner-wrapper">
                    <font-awesome-icon :icon="spinnerIcon" class="spinner"></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'
import moment from 'moment'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

export default {
    name: 'OfferDetail',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            offer: '',
            offerFetched: false,
            errorMessages: []
        }
    },
    async mounted () {
        const offerId = this.$route.params.id

        const response = await this.apiService.getOfferDetail(offerId)
        if (response instanceof APIRequestError || response instanceof APIResponseError) {
            this.errorMessages.push(response.message())
            this.offerFetched = true
            return
        }

        this.offer = response.getOffer()
        this.offerFetched = true
    },
    methods: {
        formatReward () {
            const offer = this.offer
            // Shows reward type: PERCNT_OFF = X%, AMT_OFF = $X, CPG = X¢/gal
            let reward = ''
            switch (offer.rewardType) {
            case 'PERCNT_OFF':
                if (offer.rewardAmount === 100) {
                    reward = 'FREE'
                } else {
                    reward = offer.rewardAmount + '% OFF'
                }
                break
            case 'AMT_OFF':
                reward = '$' + offer.rewardAmount + ' OFF'
                break
            case 'CPG':
                reward = Math.round(offer.rewardAmount * 100) + '&cent;/gal'
                break
            default:
                reward = offer.rewardAmount + '&cent;/gal'
            }

            return reward
        },
        formatDate (dateStr) {
            return moment(dateStr).format('l')
        },
        formatDateRange () {
            const offer = this.offer

            if (offer.startDate) {
                return 'Valid: ' + this.formatDate(offer.startDate)
            } else if (offer.endDate) {
                return 'Expires: ' + this.formatDate(offer.endDate)
            } else {
                return 'Valid: ' + this.formatDate(offer.startDate) + ' - ' + this.formatDate(offer.endDate)
            }
        },
        getOfferImage () {
            const offer = this.offer

            const image = 'https://ed0c37be21f8ad72418b-ae99f0738c1a4f0c153c7aecac9360e1.ssl.cf1.rackcdn.com/elevate/app/' + offer.imageName + '@3x.png'

            return image
        }
    },
    computed: {
        spinnerIcon () {
            return faSpinner
        }
    }
}
</script>

<style scoped lang="scss">
    .spinner-wrapper {
        margin-top: 20px;

        .fa-spinner {
            width: 50px;
            height: 50px;
        }
    }

    .offer-detail-img-wrapper {
        img {
            background-color: white;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/OfferDetail.vue